module.exports = __webpack_public_path__ + "img/logo_quadritech_bco_png.996f5c5b.png";